import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  Grid,
  Select,
  InputLabel,
  Input,
  // MenuItem,
  Modal,
  Backdrop,
  Fade,
  FormHelperText,
  NativeSelect,
  Button,
  Breadcrumbs,
  Typography,
} from "@material-ui/core";
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
//cookies
import { get_cookies } from "../../../components/Cookies/Cookies";
import numeral from "numeral";
import { useParams, useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const FacilitationReportView = () => {
  const { from, to } = useParams();
  const [uniqueID, setUniqueId] = useState("");
  const [posts, setPosts] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const classes = useStyles();

  const [useridNo, setuseridNo] = useState(get_cookies("branchidno"));
  // console.log(uniqueID);
  // Data Fetching
  useEffect(() => {
    dataFilter();
  }, []);

  useEffect(() => {
    if (posts.length > 0) {
      setDownloadFlag(true);
    } else {
      setDownloadFlag(false);
    }
  }, [posts]);
  //search button
  const dataFilter = async () => {
    setDataLoaded(false);
    await axios
      .get(process.env.REACT_APP_API_URL + "viewFacilitation", {
        params: {
          date_from: from, //format(dateRange.startDate, "yyyy/MM/dd/")
          date_to: to, //format(dateRange.endDate, "yyyy/MM/dd/")
          jc_user_id_no: useridNo,
          //   unique_id: uniqueID,
        },
      })
      .then((res) => {
        console.log("reports", res);
        setPosts(res.data.data);
      })
      .catch((error) => {
        // console.log(error.message);
      });
    setDataLoaded(true);
  };

  const data = async () => {
    setDataLoaded(true);
  };

  const toggle = () => setOpen(!open);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const dateRangeHandler = (range) => {
    setDateRange(range);
    setOpen(false);
  };
  const columns = [
    {
      name: "trandate",
      label: "Transaction Date",
    },
    {
      name: "idno",
      label: "ID No.",
    },
    {
      name: "type",
      label: "Type",
    },
    {
      name: "tagtype",
      label: "Country",
    },

        {
          name: "netamount",
          label: "Amount",
          options: {
            customHeadRender: (columnMeta) => {
              return (
                <th
                  key={columnMeta.index}
                  style={{ textAlign: "right", fontWeight: "400", textTransform: "none" }}
                >
                  Amount
                </th>
              );
            },
          
            customBodyRenderLite: (dataIndex) => {
              const type = posts[dataIndex].atype;
              const transactiontype = posts[dataIndex].upgrade;
              let value = 0;

if(transactiontype == 0){
              switch (type) {
                case "Platinum":
                  value = 300;
                  break;
                case "Sapphire":
                  value = 900;
                  break;
                case "Emerald":
                  value = 2100;
                  break;
                case "Ruby":
                  value = 4500;
                  break;
                case "Diamond":
                  value = 9300;
                  break;
                default:
                  value = 0;
}

}else{
  value = 300;
}
          
              return (
                <div style={{ textAlign: "right" }}>
                  {numeral(value).format("0,0.00")}
                </div>
              );
            },
          
            setCellProps: () => ({
              style: { textAlign: "right" },
            }),
          
            setCellHeaderProps: () => ({
              style: { textAlign: "right" }, // corrected for <th>
            }),
          },
        },
  ];

  const options = {
    filter: false,
    // filterType: "dropdown",
    selectableRows: "none",
    filterType: "multiselect",
    responsive: "standard",
    download: false, //add this
    print: false, //add this
    viewColumns: false,
    setFilterChipProps: (colIndex, colName, data) => {
      //console.log(colIndex, colName, data);
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    customTableBodyFooterRender: () => {
      const total = posts.reduce((sum, post) => {
        let multiplier = 1;

    if(post.upgrade== 0){
      if (post.atype === "Platinum") {
        multiplier = 1;
      } else if (post.atype === "Sapphire") {
        multiplier = 3;
      } else if (post.atype === "Emerald") {
        multiplier = 7;
      } else if (post.atype === "Ruby") {
        multiplier = 15;
      } else if (post.atype === "Diamond") {
        multiplier = 31;
      }
    }else{
      multiplier = 1;
    }


    
        return sum +  multiplier *300;
      }, 0);
    
      return (
        <TableFooter>
          <TableRow>
            <TableCell
              colSpan={columns.length - 1}
              align="right"
              style={{ fontWeight: "bold", color: "black" }}
            >
              Total:
            </TableCell>
            <TableCell  align="right" style={{ fontWeight: "bold", color: "black" ,textAlign:'right'}}>
              {numeral(total).format("0,0.00")}
            </TableCell>
          </TableRow>
        </TableFooter>
      );
    },

    // tableBodyHeight,
  };

  const style = {
    marginBottom: "1rem",
    marginTop: "2.5em",
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink to="/reports">
            <h2 className="header-title">Reports</h2>
          </NavLink>
          <Typography color="textPrimary">Facilitation Fee Report</Typography>
          <Typography color="textPrimary">Facilitation Fee Report View</Typography>
        </Breadcrumbs>
      </div>
      <div className="page-container">
        {!dataLoaded ? (
          <Preloader />
        ) : (
          <>
            <MUIDataTable
              title={
                <div>
                  <h3 className="header-title" style={{ color: "#339933" }}>
                    Facilitation Fee Report (From:{from} - To:{to})
                  </h3>
                </div>
              }
              data={posts}
              columns={columns}
              options={options}
            />
            <div style={{ textAlign: "right", marginBottom: "1rem" }}>
              <NavLink
                to="/reports/facilitation-report"
                style={{
                  backgroundColor: "#339933",
                  color: "#fff",
                  padding: "10px 16px",
                  borderRadius: "6px",
                  textDecoration: "none",
                  fontWeight: "bold",
                  display: "inline-block",
                  marginTop:"10px",
                }}
              >
                Back
              </NavLink>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default FacilitationReportView;
